import React from "react"

import { Text } from "@chakra-ui/react"

import RegisterConfirm from "@/components/RegisterConfirm"
import Message from "@/components/Message"
import AccountLayout from "@/components/AccountLayout"

export default function RegisterConfirmView() {
  const gradientBox = <RegisterConfirm />

  const message = (
    <Message>
      <Text fontSize="2em">Thank you for signing up for Blind Insight!</Text>
      <Text fontSize="1.5em">
        Please check your email for an activation link!
      </Text>
    </Message>
  )
  return <AccountLayout gradientBox={gradientBox} message={message} />
}
